import { render, staticRenderFns } from "./syncErpSku.vue?vue&type=template&id=563744be&scoped=true"
import script from "./syncErpSku.vue?vue&type=script&lang=js"
export * from "./syncErpSku.vue?vue&type=script&lang=js"
import style0 from "./syncErpSku.vue?vue&type=style&index=0&id=563744be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563744be",
  null
  
)

export default component.exports